import { DefaultTheme } from 'styled-components';
import { isString, toNumber } from 'lodash-es';
import { b2cVersion } from '../utils/consts.ts';
import { ENV_CONSTS } from '../utils/env-consts.ts';
import {
  gradientColors,
  rgbaColors,
  simpleColors,
  greenThemeTypedColors,
  blueThemeTypedColors,
  pinkThemeTypedColors,
} from './colors';
import { desktopData } from './consts';

const typedColors =
  ENV_CONSTS.STYLES_THEME === 'green'
    ? greenThemeTypedColors
    : ENV_CONSTS.STYLES_THEME === 'blue'
      ? blueThemeTypedColors
      : pinkThemeTypedColors;

const colors = {
  ...simpleColors,
  ...gradientColors,
  ...rgbaColors,
  ...typedColors,
} as const;

export const themeMain: DefaultTheme = {
  greenTheme: ENV_CONSTS.STYLES_THEME === 'green',
  b2cVersion,
  colors,
  breakpoints: {
    md: 1024,
  },
  responsive: (px: number) => {
    const maxSize = px;
    const minSize = (px * desktopData.min) / desktopData.normal;
    const vwSize = (px * 100) / desktopData.normal;
    return `clamp(${minSize}px, ${vwSize}vw, ${maxSize}px)`;
  },
  spacing: function (top, right, bottom, left) {
    if (right === undefined) {
      return this.responsive(top);
    }

    if (bottom === undefined) {
      return `${this.responsive(top)} ${this.responsive(right)}`;
    }

    if (left === undefined) {
      return `${this.responsive(top)} ${this.responsive(right)} ${this.responsive(bottom)}`;
    }

    return `${this.responsive(top)} ${this.responsive(right)} ${this.responsive(bottom)} ${this.responsive(left)}`;
  },
  getColor: (colorName) => colors[colorName],
  getDownMedia: function (breakpoint) {
    return `@media screen and (max-width: ${
      isString(breakpoint)
        ? toNumber(this.breakpoints[breakpoint]) - 1
        : breakpoint - 1
    }px)`;
  },
  getUpMedia: function (breakpoint) {
    return `@media screen and (min-width: ${
      isString(breakpoint) ? this.breakpoints[breakpoint] : breakpoint
    }px)`;
  },
};

export const breakpoints = themeMain.breakpoints;
